import { formatAttendanceDate } from "src/utils/formatdate";

const BusScheduleAffectedAttendances = ({ affectedAttendances }) => {
  return (
    affectedAttendances.length > 0 && (
      <div className="ms-3">
        {affectedAttendances.map(memberAttendance => {
          const member = memberAttendance[0]?.member_classes?.member;
          const memberId = member?.id;
          const memberCode = member?.member_code;
          const memberName = member?.name;

          const successfulAttendances = memberAttendance.filter(
            attendance => !attendance.update_error
          );
          const attendancesWithErrors = memberAttendance.filter(
            attendance => attendance.update_error
          );

          return (
            <div key={memberId} className="mb-3">
              <div className="fw-bold mb-2">
                会員番号{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/admin/student/details/${memberId}?action=update&key=tab4`}
                >
                  {memberCode}
                </a>
                ({memberName})
              </div>
              {attendancesWithErrors.length > 0 && (
                <div className="alert alert-danger mb-2 p-2">
                  <div className="small fw-bold mb-1">
                    エラーが発生した出席:
                  </div>
                  <div className="d-flex flex-column gap-1">
                    {attendancesWithErrors.map(attendance => (
                      <div key={attendance.id} className="small">
                        {formatAttendanceDate(attendance)}

                        <div className="text-danger">
                          エラー: {attendance.update_error}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {successfulAttendances.length > 0 && (
                <div className="alert alert-info mb-2 p-2">
                  <div className="small fw-bold mb-1">更新予定の出席:</div>
                  <div className="d-flex flex-column gap-1">
                    {successfulAttendances.map(attendance => (
                      <div key={attendance.id} className="small">
                        {formatAttendanceDate(attendance)}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    )
  );
};

export default BusScheduleAffectedAttendances;
